/**
 * 统一的主题配置
 * 用于控制所有页面的背景颜色和主题相关的颜色
 */

export type Theme = 'light' | 'dark';

/**
 * 页面背景渐变配置
 */
export const PAGE_BACKGROUND_GRADIENTS = {
  dark: 'from-[#02082f] to-[#0a5bda]',
  light: 'from-[#e6f2ff] to-[#cce5ff]',
} as const;

/**
 * 获取页面背景渐变类名
 * @param theme - 主题类型
 * @returns Tailwind CSS 渐变类名
 */
export function getPageBackgroundGradient(theme: Theme): string {
  return PAGE_BACKGROUND_GRADIENTS[theme];
}

/**
 * 获取页面背景渐变样式对象（用于内联样式）
 * @param theme - 主题类型
 * @returns CSS 渐变样式对象
 */
export function getPageBackgroundGradientStyle(theme: Theme): React.CSSProperties {
  if (theme === 'dark') {
    return {
      background: 'linear-gradient(to bottom, #02082f 0%, #0a5bda 100%)',
    };
  } else {
    return {
      background: 'linear-gradient(to bottom, #e6f2ff 0%, #cce5ff 100%)',
    };
  }
}

